import { match } from 'ts-pattern';
import { MessageMedium } from 'modules/domains/campaign';

export const createCardTitle = (messageMedium: MessageMedium) => {
  const { medium, event } = match(messageMedium)
    .with(MessageMedium.Email, () => ({ medium: 'email', event: 'opened or clicked' }))
    .with(MessageMedium.Push, () => ({ medium: 'push', event: 'opened' }))
    .with(MessageMedium.SMS, () => ({ medium: 'SMS', event: 'clicked' }))
    .otherwise(() => ({ medium: 'email', event: 'opened or clicked' }));

  return `Top ${medium} campaigns they ${event} last month`;
};

/**
 @see src/modules/campaigns/editor/types.ts, src/modules/ai/copyAssist/utils.ts
 */
export const getMessageHeaderByType = (messageMedium: MessageMedium) =>
  match(messageMedium)
    .with(MessageMedium.Email, () => 'Subject line')
    .with(MessageMedium.Push, () => 'Message')
    .with(MessageMedium.SMS, () => 'Message')
    .otherwise(() => 'Subject line');

export const createPromptSubHeader = (messageMedium: MessageMedium) =>
  match(messageMedium)
    .with(MessageMedium.Email, () => 'Select a new subject line and resend this campaign')
    .with(MessageMedium.Push, () => 'Select a new message and resend this campaign')
    .with(MessageMedium.SMS, () => 'Select a new message and resend this campaign')
    .otherwise(() => 'Select a new subject line and resend this campaign');

export const getMessageMediumDisplayText = (messageMedium: MessageMedium) =>
  match(messageMedium)
    .with(MessageMedium.Email, () => 'users who didn’t open the email')
    .with(MessageMedium.Push, () => 'users who didn’t open the push message')
    .with(MessageMedium.SMS, () => 'users who didn’t click the sms message')
    .otherwise(() => '');
